module.exports = __webpack_public_path__ + "static/media/img_Inscription_kotobuki@3x.25c7a701.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_Inscription_kotobuki@3x.png
// module id = 975
// module chunks = 0